<template>
  <ValidationObserver v-slot="{invalid,handleSubmit}" slim>
    <form @submit.prevent="handleSubmit(saveCustomInvoice)" class="justify-content-between col-lg-12 py-3">
      <p style="font-size: 2em;">Aangepaste Factuur</p>
      <div class="form-row align-items-center py-3">

        <p class="col-lg-12 font-weight-bold">Factuurgegevens</p>
        <DateInputField
            class="form-group col-lg-6" v-model="invoiceDate"
            labelText="factuurdatum" required/>
        <NumberInputField
            class="form-group col-lg-6" v-model="vatPercentage"
            labelText="BTW-percentage" required/>
        <TextInputField
            class="form-group col-lg-6" email v-model="mail"
            labelText="e-mail voor contact" required/>

        <div class="form-group col-lg-6">
          <label>E-mail(s) voor facturatie</label>
          <multiselect
              v-model="selected"
              :options="confirmedEmails"
              :multiple="true"
              :close-on-select="false"
              :clear-on-select="false"
              :preserve-search="true"
              placeholder="Selecteer één of meerdere"
              label="emailAddress"
              track-by="emailAddress"
              :preselect-first="true">
          </multiselect>
        </div>
          
        
        <p class="col-lg-12 font-weight-bold">Klantgegevens</p>
        <TextInputField
            class="form-group col-lg-6" v-model="organisationName"
            labelText="organisatienaam"
            minLength="3" maxLength="40" required/>
        <TextInputField
            class="form-group col-lg-6" v-model="financialSupervisorReference"
            labelText="aangeschrevene"
            minLength="3" maxLength="40" required/>
        <TextInputField
            class="form-group col-lg-6" v-model="street"
            labelText="straat" required/>
        <TextInputField
            class="form-group col-lg-6" v-model="houseNumber"
            labelText="huisnummer" required/>
        <TextInputField
            class="form-group col-lg-6" v-model="postalCode"
            labelText="postcode" required/>
        <TextInputField
            class="form-group col-lg-6" v-model="city"
            labelText="stad" required/>
        <TextInputField
            class="form-group col-lg-6" v-model="country"
            labelText="land" required/>
        <TextInputField
            class="form-group col-lg-6" v-model="vat"
            labelText="BTW-nummer" required
            minLength="3" maxLength="40"/>
        <div class="form-group col-lg-12">
          <label>Betalingstermijn</label>
          <select v-model="paymentTerm" class="form-control">
            <option :value="null" disabled>Kies een betalingstermijn</option>
            <option v-for="dropdownElement in paymentTermOptions"
                :key="dropdownElement.id"
                :value="dropdownElement.value">{{ dropdownElement.value }} dagen
            </option>
          </select>
        </div>
        <TextInputField
            class="form-group col-sm-6" v-model="internalReference"
            labelText="interne referentie" required/>
        <TextInputField
            class="form-group col-sm-6" v-model="externalReference"
            labelText="externe referentie" required/>
        <TextInputField
            class="form-group col-lg-12" v-model="reference"
            labelText="referentie" required/>
        <TextInputField
            class="form-group col-lg-12" v-model="disclaimer"
            labelText="disclaimer" required/>
      </div>

      <p class="col-lg-12 font-weight-bold">Vrije kosten</p>
      <table class="table b-table-fixed">
        <thead class="thead-dark">
        <tr class="d-flex">
          <th scope="col" class="col-2">Omschrijving</th>
          <th scope="col" class="col-2">Aantal</th>
          <th scope="col" class="col-2">Eenheden</th>
          <th scope="col" class="col-2">Kost</th>
          <th scope="col" class="col-2">Type</th>
          <th scope="col" class="col-2">Totaal</th>
          <th scope="col" class="col-2">Actie</th>
        </tr>
        </thead>
        <tbody>
        <tr class="d-flex" v-for="(cost, index) in freeCosts" :key="index">
          <td class="col-2">{{ cost.description }}</td>
          <td class="col-2">{{ cost.amount }}</td>
          <td class="col-2">{{ cost.units }}</td>
          <td class="col-2">{{ cost.cost }}</td>
          <td class="col-2">{{ cost.accountingCost.name }}</td>
          <td class="col-2">{{ cost.amount * cost.cost }}</td>
          <td class="col-2">
            <button class="btn-basic btn-red" @click="deleteFreeCost(cost)">Verwijder</button>
          </td>
        </tr>
        <tr v-if="showCreateFreeCost" class="d-flex">
          <td class="col-2">
            <TextInputField
                class="form-group" v-model="freeCostDescription"
                labelText="Omschrijving" required
                minLength="1" maxLength="40"/>
          </td>
          <td class="col-2">
            <NumberInputField
                class="form-group" v-model="freeCostAmount"
                label-text="Aantal" required
                maxLength="40"/>
          </td>
          <td class="col-2">
            <TextInputField
                class="form-group" v-model="freeCostUnits"
                label-text="Eenheden"
                minLength="1" maxLength="40"/>
          </td>
          <td class="col-2">
            <NumberInputField
                class="form-group"
                step="any"
                label-text="Kost"
                v-model="freeCost" required
                maxLength="40"/>
          </td>

          <td class="col-2">
            <div id="selector" class="form-group">
              <label >Type kost</label>
              <select v-model="selectedAccountingCost" class="form-control">
                <option value="" disabled selected>Selecteer type kost</option>
                <option v-bind:key="accountingCost.bilingCode" v-bind:value="accountingCost" v-for="accountingCost in accountingCosts" >
                  {{ accountingCost.name }}
                </option>
              </select>
            </div>
          </td>
          <td class="col-2">{{ freeCostAmount * freeCost }}</td>

        </tr>
        </tbody>
      </table>


      <div class="d-flex justify-content-start">
        <button :disabled="!canAddFreeCost" v-if="showCreateFreeCost" @click="createFreeCost" class="btn-basic btn-fill-pulse">Opslaan</button>
        <button v-if="showCreateFreeCost" @click="toggleCreateFreeCost" style="margin-left: 2%;"  class="btn-basic btn-fill-pulse-dark">Annuleren</button>
        <button v-if="!showCreateFreeCost" @click="toggleCreateFreeCost" class="btn-basic btn-fill-pulse">Toevoegen</button>
      </div>

      <div class="form-group col-lg-12">
        <button
            type="submit" :disabled="invalid"
            class="btn-basic btn-fill-pulse">
          Factuur aanmaken
        </button>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import TextInputField from "@/components/inputFields/TextInputField";
import DateInputField from "@/components/inputFields/DateInputField";
import NumberInputField from "@/components/inputFields/NumberInputField";
import {ValidationObserver} from "vee-validate";
import {mapActions, mapGetters} from "vuex";
import Multiselect from 'vue-multiselect';

export default {
  name: "AdminViewCustomInvoice",
  components: {
    DateInputField,
    NumberInputField,
    TextInputField,
    ValidationObserver,
    Multiselect
  },
  data: () => ({
    organisationName: "",
    financialSupervisorReference: "",
    street: "",
    houseNumber: "",
    postalCode: "",
    city: "",
    country: "",
    vat: "",
    paymentTerm: null,
    paymentTermOptions: [{"id": 1, "value": 30}, {"id": 2, "value": 60}, {"id": 3, "value": 90}],
    invoiceDate: "",
    vatPercentage: 0,
    mail: "",
    reference: "",
    freeCosts: [],
    freeCostDescription: "",
    freeCostAmount: 0,
    freeCostUnits: "",
    freeCost: 0,
    disclaimer: "Vrijgesteld van BTW volgens art. 44 paragraaf 2 van het BTW-wetboek",
    showCreateFreeCost: false,
    selectedAccountingCost: "",
    selectedConfirmedEmail: "",
    internalReference:"",
    externalReference:"",
    selected:[]
  }),
  computed: {
    ...mapGetters({
      accountingCosts: "administrationInvoice/accountingCosts",
      confirmedEmails: "administrationInvoice/confirmedEmails"
    }),

    canAddFreeCost() {
      return this.isTextInputValid(this.freeCostDescription) &&
          this.isPositiveNumber(this.freeCostAmount) &&
          this.isTextInputValid(this.freeCostUnits) &&
          this.isNumber(this.freeCost) &&
          this.selectedAccountingCost !== "";
    }
  },
  async created() {
    await this.fetchAccountingCostsList();
    await this.fetchConfirmedEmailsList();
  },
  methods: {

    ...mapActions("administrationInvoice", [
      'createCustomInvoice', 'fetchAccountingCostsList','fetchConfirmedEmailsList'
    ]),
    isTextInputValid(text) {
      return text.trim().length > 0 && text.trim().length < 41;
    },
    isNumber(number) {
      return number !== 0;
    },
    isPositiveNumber(number){
      return number>0;
    },
    saveCustomInvoice() {
      const createInvoiceDto = {
        invoiceDate: this.invoiceDate,
        VATPercentage: this.vatPercentage,
        contactMail: this.mail,
        confirmedEmailDtos: this.selected,
        customerBillingDto: {
          organisationName: this.organisationName,
          financialSupervisorReference: this.financialSupervisorReference,
          street: this.street,
          houseNumber: this.houseNumber,
          postalCode: this.postalCode,
          city: this.city,
          country: this.country,
          vat: this.vat,
          paymentTerm: this.paymentTerm
        },
        internalReference: this.internalReference,
        externalReference: this.externalReference,
        reference: this.reference,
        disclaimer: this.disclaimer,
        freeCostBillingDto: this.freeCosts,
        accountingCostDto: this.accountingCosts,
      };

      this.createCustomInvoice(createInvoiceDto);
      this.$router.push({path: "/admin/viewinvoicedetail"});
    },
    toggleCreateFreeCost(e) {
      this.showCreateFreeCost = !this.showCreateFreeCost;
      this.resetFreeCost();
      e.preventDefault();
    },
    createFreeCost(e) {
      const description = this.freeCostDescription;
      const amount = this.freeCostAmount;
      const units = this.freeCostUnits;
      const cost = this.freeCost;
      const accountingCost = this.selectedAccountingCost;
    
      const createFreeCostDto = {
        description,
        amount,
        units,
        cost,
        accountingCost,
      };

      e.preventDefault();
      this.freeCosts.push(createFreeCostDto);
      this.toggleCreateFreeCost(e);
    },
    deleteFreeCost(costToDelete) {
      this.freeCosts = this.freeCosts.filter(cost => cost !== costToDelete);
    },
    resetFreeCost() {
      this.freeCostDescription = "";
      this.freeCostAmount = 0;
      this.freeCostUnits = "";
      this.freeCost = 0;
      this.selectedAccountingCost = "";
    }
  }
};
</script>
<style scoped>
.text-red {
  color: red;
}
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>